exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tile[data-v-4213e73a]:hover{background:#d3d3d3}", ""]);

// exports
